export default __webpack_public_path__ + "static/media/quiz-generator.25dd8ff7.jpg";